export default __webpack_public_path__ + "static/media/2.39d895c7.png";